export default "assets/images/logo-8e6d1102.svg";